<template>
    <div v-loading="pageLoading">
        <tab :name="appType == 0 ? '2' : '1'"></tab>
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="40">                
                <el-col :xs="24" :sm="12" :xl="8">
                    <!-- <el-form-item prop="appType" label="对象类型">
						<template v-if="appType == 0 ">APP专业版</template>
						<template v-if="appType == 1 ">APP乐迷版</template>
                    </el-form-item> -->
                    <el-form-item prop="versionCode" label="版本">
				        <el-input  v-model="formData.versionCode" maxlength="20" placeholder="请输入版本" size="medium"></el-input>
				    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="versionTerminal" label="客户端" size="medium">
                        <el-radio-group v-model="formData.versionTerminal" @change="versionTerminalChange">
                            <el-radio :label="1">iOS</el-radio>
                            <el-radio :label="2">Android</el-radio>
                            <el-radio v-if="appType == 1" :label="4">鸿蒙</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
				<el-col :xs="24" :sm="12" :xl="8">
				    <el-form-item prop="versionName" label="版本标题">
				        <el-input v-model="formData.versionName" maxlength="40" placeholder="请输入版本标题" size="medium"></el-input>
				    </el-form-item>
				</el-col>
				<el-col  :xs="24" :sm="12" :xl="8">
					<el-form-item label="版本说明" prop="content"  >
						<el-input type="textarea"  v-model="formData.content" maxlength="1000"  placeholder="请输入版本说明" show-word-limit></el-input>
					</el-form-item>
				</el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="force" label="强制更新">
						<span slot="label">
						    强制更新：
						    <small class="color-danger"><span class="el-icon-warning"></span> 开启视为要求该版本的用户强制更新到最新版本</small>
						</span>
                        <el-radio-group v-model="formData.force" size="medium">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
					<el-form-item v-if="formData.versionTerminal == 1 || formData.versionTerminal == 4" prop="url" label="升级链接" :rules="{ required: true, message: '请填写升级链接'}">
						<el-input  v-model="formData.url"  maxlength="200" placeholder="请输入升级链接" size="medium"></el-input>
					</el-form-item>
                    <el-form-item v-else prop="url" :rules="{ required: true, message: '请上传安装包'}">
                        <span slot="label">
						    安装包
						    <small class="color-danger"><span class="el-icon-warning"></span> 只能上传apk文件</small>
						</span>
                        <el-upload
                            action
                            :http-request="uploadApk"
                            ref="upload"
                            :file-list="fileList"
                            :disabled="uploadLoading"
                            accept=".apk"
                            :on-change="onChange"
                            :on-remove="onRemove">
                            <el-button size="medium" type="primary" plain :disabled="uploadLoading" icon="el-icon-upload2" :loading="uploadLoading">{{!formData.url ? '点击上传' : '重新上传'}}</el-button>
                        </el-upload>
                        <div v-if="formData.url" class="MT10">
                            <el-button  size="medium" icon="el-icon-download" :disabled="uploadLoading" @click="downloadApk">下载文件</el-button>
                        </div>
					</el-form-item>
				</el-col> 
			</el-row>
			<el-row :gutter="40" v-if="formData.force == 1">
				<el-col  :xs="24" :sm="12" :xl="8">
					<el-form-item label="强制更新标题" prop="forceTitle">
						<el-input v-model="formData.forceTitle" maxlength="40" placeholder="请输入强制更新标题" size="medium"></el-input>
					</el-form-item>
					<el-form-item label="强制更新说明" prop="forceContent">
						<el-input type="textarea"  v-model="formData.forceContent" maxlength="200"  placeholder="请输入强制更新说明"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
            <el-form-item>
                <el-button @click="goBack">返回取消</el-button>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    v-if="$utils.have('/app/info/update')"
                    >确认提交</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Tab from './components/tab'
import {uploadFile} from '@/assets/js/commonApi.js';
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
		appType:{
			type: [Number, String],
			default: null,
		}
    },
    components: {
		Tab
	},
    data() {
        const isNum = (rule, value, callback) => {
            const reg = /^(\d+\.)*\d+$/;
            if (value !== '') {
                if(reg.test(value)){
                    callback();                    
                }else{
                    return callback(new Error('版本号不正确'));
                }                
            }            
        };
        return {
            formData: {
				appType:this.appType,
                versionTerminal: 1,
                force: 0,
                versionCode:'',
                versionName: '',
                url: '',
                content: '',
				forceTitle:'',
				forceContent:''
            },
            rules: {
               // appType: [{ required: true, message: "请选择对象类型" }],
                versionTerminal: [{ required: true, message: "请选择客户端"}],
                force:[{ required: true, message: "请选择是否强制更新"}],
                versionCode: [
                    { required: true, message: "请填写版本号"},
                    { validator: isNum, trigger: 'blur' }
                ],
                versionName: [{ required: true, message: "请填写版本标题"}],
				content: [{ required: true, message: "请填写版本说明"}],
                // url: [{ required: true, message: "请填写升级链接"}]
            },
            btnLoading: false,
            pageLoading: false,
            redirect: this.appType == 1 ? '/operation/updateNotify/listyuemi': '/operation/updateNotify/list',
			appTypeNew:'',
            uploadLoading: false,
            fileList: []
        };
    },
    created() {
        if (this.id) {
            this.getData();
        }else{
            this.setDefaultUrl();
        }
    },
    methods: {     
        //设置IOS默认链接
        setDefaultUrl(){
            //APP乐迷版
            if( this.appType == 1 ){
                if( this.formData.versionTerminal == 1 ){
                    this.formData.url = 'https://itunes.apple.com/cn/app/xiu-dong/id923912459?l=zh&ls=1&mt=8';
                }
            }
            // APP专业版
            else{
                if( this.formData.versionTerminal == 1 ){
                    this.formData.url = 'https://itunes.apple.com/cn/app/xiu-dong-zhuan-ye-ban-shang/id1059609438?l=zh&ls=1&mt=8';
                }
            }
        },   
        // 获取详情
        getData() {
            this.pageLoading = true;
            this.$request({
                url: "/app/info/getById",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {...result};
                    if(this.formData.versionTerminal == 2){
                        const _fileName = this.formData.url.substring(this.formData.url.lastIndexOf('/') + 1);
                        this.fileList = [{
                            name: _fileName,
                            url: this.formData.url
                        }];
                    }
                } else {
                    return this.$message.error(msg || "获取详情失败");

                }
            }).finally(() => {
                this.pageLoading = false;
            });
        },
        //表单提交
        onSubmit() {
			console.log(this.formData.appType)
			
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const url = !this.id ? "/app/info/create" : "/app/info/update";
                    const data = {...this.formData,appType:this.appType};
                    this.$request({
                        url,
                        method: "POST",
                        data,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },
        //切换终端
        versionTerminalChange() {
            this.formData.url = '';
            this.fileList = [];
            this.$refs.formData.clearValidate('url');
        },
        //选择文件
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
            }
        },
        //删除文件
        onRemove(){
            this.fileList = [];
            this.formData.url = '';
        },
        // 上传文件
        async uploadApk(req){
            const {name} = req.file;
            if(!name.endsWith('.apk') ){
                this.$message.error('请上传apk文件');
                return;
            }
            const formData = new FormData();
            formData.append('file', req.file);

            this.uploadLoading = true;

            const res = await uploadFile(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                this.formData.url = result.urlFull;
            }else{
                this.$message.error(msg || '上传失败');
            }
            this.uploadLoading = false;
        },
        //下载文件
        downloadApk(){
            this.$utils.exportFileUrl(this.formData.url);
        }
    },
};
</script>